import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Section from '../Section/Section';

const useStyles = makeStyles(theme => ({
  section: {
    backgroundImage: 'url("assets/images/HomeArrows.svg")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right bottom',
  },
}));

/**
 * Component to display the sections
 *
 * @param {Object} props
 */
const SectionWithArrows = props => {
  const { children, className, propClasses = {}, style } = props;

  const classes = useStyles();

  return (
    <div className={clsx(classes.section, className)} style={style}>
      <Section className={propClasses.section} {...props}>{children}</Section>
    </div>
  );
};

SectionWithArrows.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Children to placed inside the section
   */
  children: PropTypes.node,
};

export default SectionWithArrows;
